import queryString from 'query-string';
import { request } from '../utils/request';

export const anketaAPIs = {
  getAnketaFile: (docUuid) =>
    request(`/users/current/document-anketa?${queryString.stringify({ docUuid })}`, { method: 'GET' }, true),
  uploadAnketaFile: (body) => request(`/users/current/document-anketa`, { method: 'PUT', body }),
};
